import React from "react";
import ArticleLeft from "../../components/article/ArticleLeft";
import ArticleRight from "../../components/article/ArticleRight";
import Banner from "../../components/article/Banner";
import "./blog.css";
import hackathon from "../../assets/work-img/hackathon.png";
import automechanika from "../../assets/work-img/messe.jpg";

const Blog = () => (
  <div className="blog section__padding" id="about">
    <div className="blog-heading">
      <h1 className="gradient__text">About me, My work.</h1>
    </div>
    <div className="blog-container">
      <div className="blog-container_groupA">
        <ArticleLeft text="Pixel-Perfect and Responsive Design" />
      </div>
      <div className="blog-container_groupB">
        <ArticleRight text="Clean Code" />
      </div>
    </div>

    <div className="more-projects">
      {/* <button className="button" ><span>More </span></button> */}
      <Banner text="Hier muss ein Text einstellen!" />
    </div>

    <section className="section_work-images">
      <div className="gpt3__possibility-content work-text">
        <h1 className="gradient__text">Microsoft AI Hackathon</h1>
        <p>
          Contributed to innovative, AI-driven solutions during the Microsoft AI
          Hackathon, collaborating with teams to push creative ideas forward.
        </p>
        <a
          href="https://www.linkedin.com/posts/denis-danailov-36b077192_generativeai-microsoft-aoai-activity-7173932536971046912-JCaP?utm_source=share&utm_medium=member_desktop&rcm=ACoAAC03SEMBGPEYImn0NsIcL0Hm1k4yaaxfq58"
          target="_blank"
          rel="noopener noreferrer"
          className="custom-btn"
        >
          Read more
        </a>
      </div>
      <div className="container work_container">
        <div className="my-work-first">
          <div className="my-work-image">
            <img src={hackathon} alt="hackathon-ai-microsoft" />
          </div>
        </div>
      </div>
    </section>

    <section className="section_work-images">
      <div className="container work_container">
        <div className="my-work-second">
          <div className="my-work-image">
            <img src={automechanika} alt="hackathon-ai-microsoft" />
          </div>
        </div>
      </div>
      <div className="gpt3__possibility-content work-text">
        <h1 className="gradient__text">Automechanika Frankfurt</h1>
        <p>
          Supported the launch of a new AI product at Automechanika Frankfurt,
          showcasing our development work to industry professionals.
        </p>
        <a
          href="https://www.linkedin.com/posts/denis-danailov-36b077192_silvie-ai-automechanika-activity-7240629571069386752-bLXZ?utm_source=share&utm_medium=member_desktop&rcm=ACoAAC03SEMBGPEYImn0NsIcL0Hm1k4yaaxfq58"
          target="_blank"
          rel="noopener noreferrer"
          className="custom-btn"
        >
          Read more
        </a>
      </div>
    </section>
  </div>
);

export default Blog;
